export const forums = {
  forumsSearchInputPlaceholder: '검색',
  forumsFollowDiscussionButtonTitle: '팔로우',
  forumsFollowingDiscussButtonTitle: '팔로잉 중',
  forumDiscussionInfoNoReplyText: '아직 답글이 없습니다',
  forumsDiscussionDetailsStartButtonTitle: '토론 시작',
  forumDetailsCreatedByText: '작성자',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: '링크 복사',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: '콘텐츠 신고',
  forumsReportedCurtainContent: '콘텐츠가 신고되었습니다',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: '링크가 복사되었습니다!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: '토론 고정',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: '토론 고정 해제',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: '토론 편집',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: '토론 삭제',
  forumsDiscussionDetailspPopupDeleteTitle: '삭제',
  forumsDiscussionDetailspPopupDeleteText: '이 토론을 삭제하시겠습니까?',
  forumsDiscussionDetailspPopupCancelButtonTitle: '취소',
  forumsDiscussionDetailspPopupConfirmButtonTitle: '확인',
  forumsDiscussionDetailsDeleledAlertText: '토론이 삭제되었습니다!',
  forumsNewDiscussionTitle: '새 토론',
  forumsNewDiscussionTitlePlaceholder: '제목...',
  forumsNewDiscussionBodyPlaceholderText: '여기에 텍스트를 입력하세요...',
  forumsNewDiscussionPublishButtonTitle: '게시',
  forumsNewDiscussionLocationCurtainTitle: '위치',
  forumsNewDiscussionLocationCurtainInputPlaceholder: '위치 이름',
  forumsNewDiscussionEditLocationCurtainText: '위치 편집',
  forumsNewDiscussionDeleteLocationCurtainText: '위치 삭제',
  forumsNewDiscussionCreatePollTitle: '투표 생성',
  forumsNewDiscussionTitleInputPlaceholder: '제목',
  forumsNewDiscussionOptionInputPlaceholder: '옵션',
  forumsNewDiscussionAddButtonTitle: '옵션 추가',
  forumsNewDiscussionCreateButtonTitle: '생성',
  forumsNewDiscussionPollTitleBlankAlertText: '제목은 비워둘 수 없습니다!',
  forumsNewDiscussionPollOptionBlankAlertText: '옵션은 비워둘 수 없습니다!',
  forumsNewDiscussionPollLongTitleAlertText: '제목은 최대 140자까지 포함해야 합니다',
  forumsNewDiscussionPollLongOptionAlertText: '옵션은 최대 25자까지 포함해야 합니다',
  forumsNewDiscussionEditPollIconText: '투표 편집',
  forumsNewDiscussionRemovePollIconText: '투표 제거',
  forumsDiscardDraftPopupTitle: '드래프트',
  forumsDiscardDraftPopupText: '이 드래프트를 삭제하시겠습니까?',
  forumsDiscardDraftPopupCancelButtonTitle: '취소',
  forumsDiscardDraftPopupConfirmButtonTitle: '확인',
  forumsDiscussionDetailsPostBodyReplyIconTitle: '답글',
  forumsDiscussionDetailsNoCommentsText: '아직 댓글이 없습니다\n첫 번째 댓글을 남겨보세요',
  forumsDiscussionDetailsReplyInputPlaceholder: '답글',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: '링크 복사',
  forumsDiscussionDetailsPostShareCopiedAlertText: '링크가 복사되었습니다!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: '콘텐츠 신고',
  forumsDiscussionDetailsPostCurtainReportedText: '콘텐츠가 신고되었습니다',
  forumsDiscussionDetailsCommentReplyIconTitle: '답글',
  forumsEditDiscussionTitle: '토론 편집',
  forumsEditDiscussionSaveButtonTitle: '저장',
  forumsEditedDiscussionSavedAlertText: '토론이 저장되었습니다!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: '답글 편집',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: '답글 삭제',
  forumsDiscussionDetailsEditedCommSavedAlertText: '댓글이 저장되었습니다!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: '댓글이 삭제되었습니다!',
  forumsAlertSomethinWrong: '문제가 발생했습니다!',
  forumsMaxMbSize: '한 번에 {size} MB 이상 업로드할 수 없습니다',
  forumsMaxAttachments: '첨부 파일 수가 최대치를 초과했습니다. 최대 첨부 파일 수는 {max}입니다',
  forumsDiscussionDetailsDeleteCommentPopupTitle: '삭제',
  forumsDiscussionDetailsDeleteCommentPopupText: '이 댓글을 삭제하시겠습니까?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: '취소',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: '확인',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: '콘텐츠 신고',
  forumsDiscussionDetailsCommentReportedCurtainText: '콘텐츠가 신고되었습니다',
  forumDiscussionInfoLastReplyText: '최근 답글',
  forumsDiscussionAt: '에서',
  forumsDiscussionDetailsFlagCurtainTitle: '신고',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: '콘텐츠가 신고되었습니다',
  forumsPollInfoVotesText: '투표 수',
  forumsPollInfoEditVoteText: '투표 편집',
  forumsPollFinishPollText: '투표 마감',
  forumsPollFinishedPollText: '마감됨',
  forumsPollInProgresslText: '진행 중',
  forumsPollCurtainTitle: '투표 마감',
  forumsPollCurtainText: '투표가 마감된 후에는 사용자가 투표할 수 없습니다.',
  forumsFinishPollCurtainCancelButtonTitle: '취소',
  forumsFinishPollCurtainConfirmlButtonTitle: '확인',
  forumsPollInfoPollVotesCurtainTitle: '투표 수'
}
